import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { receiveAccount, receiveCurrentAccount, receiveSelectedAccount } from '../redux/actions/account-actions';
import { receiveLogout } from '../redux/actions/login-form-actions';
import { getAccount as getUserAccount } from '../services/user-service';
import { getSelectedAccountId, getAccount } from '../services/account-service';

export default function useAccount() {
  const dispatch = useDispatch();

  const selectedAccountId = getSelectedAccountId();

  const account = useSelector((/** @type {Object} */ state) => state.account);
  const currentAccount = useSelector((/** @type {Object} */ state) => state.currentAccount);

  const dispatchAccount = useCallback(
    (a) => {
      dispatch(receiveAccount(a));
    },
    [dispatch]
  );

  const dispatchCurrentAccount = useCallback(
    (currAccount) => {
      dispatch(receiveCurrentAccount(currAccount));
    },
    [dispatch]
  );

  const dispatchLogout = useCallback(() => {
    dispatch(receiveLogout);
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      if (selectedAccountId) {
        try {
          const [userAccount, selectedAccount] = await Promise.all([getUserAccount(), getAccount(selectedAccountId)]);
          dispatch(receiveSelectedAccount(selectedAccount));
          dispatchAccount(userAccount);
          dispatchCurrentAccount(userAccount);
        } catch {
          dispatchLogout();
        }
      } else {
        try {
          const userAccount = await getUserAccount();
          dispatchAccount(userAccount);
          dispatchCurrentAccount(userAccount);
        } catch {
          dispatchLogout();
        }
      }
    })();
  }, []);

  return [account, currentAccount];
}
